// What the Files tab says next to the Traffic Violation Template.
//
// The template leaves out fines paid by the customer at RTA, fines with no contract and fines
// already on Ejar, so "every fine in the range" is not the number of rows in the file (40 fines
// on the day, 30 already on Ejar -> the row said 40, the file had 10). Before a download the
// range count is shown as what it is; after one, the rows the engine actually wrote (X-Rows).

/**
 * @param {number} inRange          fines in the chosen violation-day range
 * @param {{rows:number, skipped:number, other:number}|null} result  the last download for this range
 * @returns {{value: number, note: string}}
 */
export function templateCount(inRange, result) {
    if (!result) return { value: inRange, note: 'fines in range' };
    const left = Number(result.skipped || 0) + Number(result.other || 0);
    const parts = [];
    if (result.skipped) parts.push(`${result.skipped} already on Ejar`);
    if (result.other) parts.push(`${result.other} paid by customer / no contract`);
    return { value: Number(result.rows || 0), note: left ? `rows in the file (${parts.join(', ')} left out)` : 'rows in the file' };
}

export default templateCount;
